import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import './index.css';
import { useScrollToTop } from './lib/hooks/useScrollToTop';

// Lazy load all pages for code splitting
const Home = lazy(() => import('./pages/Home'));
const Learn = lazy(() => import('./pages/Learn'));
const Recipes = lazy(() => import('./pages/Recipes'));
const RecipeDetail = lazy(() => import('./pages/RecipeDetail'));
const Safety = lazy(() => import('./pages/Safety'));
const Glossary = lazy(() => import('./pages/Glossary'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Resources = lazy(() => import('./pages/Resources'));
const Disclaimer = lazy(() => import('./pages/Disclaimer'));

function App() {
  useScrollToTop();

  return (
    <div className='min-h-screen flex flex-col'>
      <Header />
      <main className='flex-grow'>
        <Suspense fallback={
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        }>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/learn' element={<Learn />} />
            <Route path='/recipes' element={<Recipes />} />
            <Route path='/recipe/:recipeId' element={<RecipeDetail />} />
            <Route path='/safety' element={<Safety />} />
            <Route path='/glossary' element={<Glossary />} />
            <Route path='/faq' element={<FAQ />} />
            <Route path='/resources' element={<Resources />} />
            <Route path='/disclaimer' element={<Disclaimer />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;
